export default "__VITE_ASSET__203dee79__"